import React, { useEffect, useState } from "react";
import { getWrapupCodes } from "../utilities/genesysCloudUtils";
import "../App.css";
import { CatalogTableSurface } from "./CatalogTableSurface";

export function WrapupCodes({
  checkedDivisions,
  setPageCount,
  pageNumber,
  setPageNumber,
  setTabName,
  opts,
  setOpts,
  setIsVisible,
  selectedExportRows = {},
  exportStatus,
  onClearExportSelection,
  onExportCsv,
  onToggleExportRow,
  onToggleVisibleExportRows,
}) {
  const [wrapupCodes, setWrapupCodes] = useState([]);

  useEffect(() => {
    setPageNumber(1)
    setTabName("wrapup-codes-tab");
    setOpts({})
    setIsVisible({ divisions: false, object: false, applyButton: false })
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    generateWrapupCodes();
  }, [pageNumber]); // eslint-disable-line react-hooks/exhaustive-deps

  const generateWrapupCodes = () => {
    let opts = {
      pageSize: 500, // Number | Page size
      pageNumber: pageNumber,
      sortBy: "name", // String | Sort by
      sortOrder: "ascending", // String | Sort order
    };
    getWrapupCodes(opts).then((data) => {
      setWrapupCodes(data.entities);
      setPageCount(data.pageCount);
    });
  };

  const allVisibleSelected = wrapupCodes.length > 0 && wrapupCodes.every((wrapupCode) => selectedExportRows[wrapupCode.id]);

  return (
    <CatalogTableSurface
      allVisibleSelected={allVisibleSelected}
      exportStatus={exportStatus}
      onClearSelection={onClearExportSelection}
      onExportCurrent={() => onExportCsv({ mode: "current", records: wrapupCodes })}
      onExportFiltered={() => onExportCsv({ mode: "all" })}
      onExportSelected={() => onExportCsv({ mode: "selected" })}
      onSelectVisible={(checked) => onToggleVisibleExportRows(wrapupCodes, checked)}
      rowCount={wrapupCodes.length}
      selectedCount={Object.keys(selectedExportRows).length}
      title="Wrapup Codes"
    >
      {wrapupCodes ? (
        <>
          <table className="table">
            <thead>
              <tr>
                <th aria-label="Select rows" className="select-column"></th>
                <th className="count-column">Count</th>
                <th>Wrap-Up Code</th>
                <th>Division</th>
                <th>Wrap-Up Code Id</th>
              </tr>
            </thead>
            <tbody>
              {wrapupCodes.map((wrapupCode, index) => {
                return (
                  <tr key={wrapupCode.id}>
                    <td className="select-column">
                      <input
                        aria-label={`Select ${wrapupCode.name} for export`}
                        checked={Boolean(selectedExportRows[wrapupCode.id])}
                        onChange={(event) => onToggleExportRow(wrapupCode, event.target.checked)}
                        type="checkbox"
                      />
                    </td>
                    <th className="index count-column">
                      {pageNumber === 1
                        ? index + 1
                        : (pageNumber - 1) * 500 + index + 1}
                    </th>
                    <td>{wrapupCode.name}</td>
                    <td>{wrapupCode.division.name ? wrapupCode.division.name : ""}</td>
                    <td>
                      <kbd className="kbd">{wrapupCode.id}</kbd>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      ) : (
        <h1>Loading...</h1>
      )}
    </CatalogTableSurface>
  );
}
